const state = () => ({
   lookups: [],
   activeLookupId: null,
});

const getters = {
   lookups: (state) => state.lookups,
   activeLookup: (state) =>
      state.activeLookupId !== null
         ? state.lookups.find((l) => l.id === state.activeLookupId) || null
         : null,
};

const mutations = {
   setLookups(state, lookups) {
      state.lookups = lookups;
   },
   upsertLookup(state, lookup) {
      const idx = state.lookups.findIndex((l) => l.id === lookup.id);
      if (idx >= 0) {
         state.lookups.splice(idx, 1, lookup);
      } else {
         state.lookups.unshift(lookup);
      }
   },
   setActiveLookupId(state, id) {
      state.activeLookupId = id;
   },
   removeLookup(state, id) {
      state.lookups = state.lookups.filter((l) => l.id !== id);
      if (state.activeLookupId === id) {
         state.activeLookupId = null;
      }
   },
};

const actions = {
   async loadHistory({commit}) {
      const response = await this._vm.$httpNoStudy.get('/api/prospect-lookup');
      commit('setLookups', response.data.results);
   },

   async submitUrl({commit}, url) {
      const response = await this._vm.$httpNoStudy.post('/api/prospect-lookup', {url});
      const lookup = response.data;
      commit('upsertLookup', lookup);
      commit('setActiveLookupId', lookup.id);
      return lookup;
   },

   async pollLookup({commit}, id) {
      const response = await this._vm.$httpNoStudy.get(`/api/prospect-lookup/${id}`);
      const lookup = response.data;
      commit('upsertLookup', lookup);
      return lookup;
   },
   async deleteLookup({commit}, id) {
      await this._vm.$httpNoStudy.delete(`/api/prospect-lookup/${id}`);
      commit('removeLookup', id);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
